// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__26ZL8","row":"styles_row__2T8aW"};